module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "bg weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_c('div', {
    ref: "boxWrap",
    staticClass: "dof-confirm-box-wrap weex-ct weex-div",
    style: ({
      height: _vm._px2rem(_vm.wrapHeight, 75),
      bottom: _vm._px2rem('0px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.title) ? _c('p', {
    staticClass: "title weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('dof-image', {
    staticClass: "closeIcon",
    attrs: {
      "src": "../../assets/img/check/disuncheked.png",
      "width": "40px",
      "height": "40px",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slot-floor weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: [_vm.isipx ? 'bottom-offset-padding' : ''],
    attrs: {
      "weex-type": "div"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f03a779", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f03a779","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-confirm-box/index.vue
// module id = 595
// module chunks = 0 1